/*
 * Views for individual campaign
 */

define(["marionette", "./template/campaignTemplate.html"], function (Marionette, CampaignTemplate) {
  const CampaignView = {};

  CampaignView.campaignLayout = Marionette.Layout.extend({
    template: CampaignTemplate,
    regions: {
      runCampaign: "#runCampaign",
      campaignInfo: "#campaignInfo",
      campaignLaunch: "#campaignLaunch",
    },
  });

  return CampaignView;
});
